var map = {
	"./Australia.png": 7909,
	"./Brazil.png": 5177,
	"./Canada.png": 6313,
	"./Chile.png": 4964,
	"./England.png": 7044,
	"./France.png": 1230,
	"./Germany.png": 4468,
	"./Ireland.png": 86,
	"./Italy.png": 2406,
	"./Japan.png": 1843,
	"./Sweden.png": 395,
	"./USA.png": 4482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2636;